import React from "react";

import { IBannerRedirection } from "@/models";

import useIsMobile from "./useIsMobile";
import useIsTablet from "./useIsTablet";

import { useAppDispatch } from "@/store/hooks";
import { setIsRequestCallBackOpen } from "@/store/slices/config";

const useBannerRedirection = () => {
  const { isMobile } = useIsMobile();
  const { isTablet } = useIsTablet();

  const dispatch = useAppDispatch();

  const bannerRedirectionHandler = (bannerRedirection: IBannerRedirection) => {
    switch (bannerRedirection) {
      case IBannerRedirection.FIND_DOCTOR:
        return "/find-doctor";
      case IBannerRedirection.MEDICINES:
        return "/medicines";
      case IBannerRedirection.TEST:
        return "/test-reports";
      case IBannerRedirection.HEALTH_HUB:
        return "/health-hub";
      case IBannerRedirection.HELP_ME_CHOOSE_FORM:
        if (isMobile || isTablet) {
          dispatch(setIsRequestCallBackOpen());
        }
        return "/find-doctor";
      case IBannerRedirection.SUPPORT_CHAT:
        return "/chat";
      case IBannerRedirection.ALL_ORDERS:
        return "/order-list";
      case IBannerRedirection.HEALTH_ASSESSMENT_BRAIN:
        return "/health-assessment?type=Brain";
      case IBannerRedirection.HEALTH_ASSESSMENT_SPINE:
        return "/health-assessment?type=Spine";
      case IBannerRedirection.PROFILE_MEDICAL_RECORDS:
        return "/medical-records";
      case IBannerRedirection.CHAT_LIST:
        return "/chat";
      default:
        return "/home";
    }
  };
  return { bannerRedirectionHandler };
};

export default useBannerRedirection;
